import { Route } from '@angular/router';
import { inject } from '@angular/core';
import { RouteIds } from '../../../types';
import { QuoteStepComponent } from './quote-step.component';
import { StepResolverService } from '../../../services';

export const quoteStepRoute: Route = {
  path: RouteIds.quote,
  resolve: { step: () => inject(StepResolverService).resolve(RouteIds.quote) },
  component: QuoteStepComponent,
};
